/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransferredToken
 */
export interface TransferredToken {
    /**
     * 
     * @type {string}
     * @memberof TransferredToken
     */
    transferredToken: string;
}

/**
 * Check if a given object implements the TransferredToken interface.
 */
export function instanceOfTransferredToken(value: object): boolean {
    if (!('transferredToken' in value)) return false;
    return true;
}

export function TransferredTokenFromJSON(json: any): TransferredToken {
    return TransferredTokenFromJSONTyped(json, false);
}

export function TransferredTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferredToken {
    if (json == null) {
        return json;
    }
    return {
        
        'transferredToken': json['transferred_token'],
    };
}

export function TransferredTokenToJSON(value?: TransferredToken | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'transferred_token': value['transferredToken'],
    };
}

